export default __webpack_public_path__ + "ff792b752af8915bf5e7adca35949f30.png";